import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

export const errorToast = (text, duration = 5000) => {
  Toastify({
    text,
    duration,
    close: true,
    gravity: 'bottom', // `top` or `bottom`
    position: 'right', // `left`, `center` or `right`
    stopOnFocus: true, // Prevents dismissing of toast on hover
    style: { background: 'red' },
  }).showToast();
};

export const successToast = (text, duration = 5000) => {
  Toastify({
    text,
    duration,
    close: true,
    gravity: 'bottom', // `top` or `bottom`
    position: 'right', // `left`, `center` or `right`
    stopOnFocus: true, // Prevents dismissing of toast on hover
    style: { background: '#c6e300', color: '#000000' },
  }).showToast();
};
